import { GlobalContexts, useGlobals }                     from '@/hooks/use-globals';
import { Computed, ObjectWithStringKeys, ValidationRule } from '@/types';
import { Impacts }                                        from '@/views/events/submodules/events-detail.types';
import { blankValidator }                                 from '@/helpers/validators';

export const useEventDetailRules = (impacts: Computed<Impacts[]>): ObjectWithStringKeys<ValidationRule[]> => {
  const { store, i18n }: GlobalContexts = useGlobals();

  return impacts.value.reduce((acc: ObjectWithStringKeys<any>, curr: Impacts, index: number) => ({
    ...acc,
    [ `impacts[${index}].value` ]: {
      required: true,
      message: i18n.t(`${store.state.i18n.GLOBAL_PATH}.rules.required`, [ 'Impact' ])
        .toString(),
      trigger: 'submit',
    },
  }), {
    name: [
      {
        required: true,
        message: i18n.t(`${store.state.i18n.GLOBAL_PATH}.rules.required`, [ 'Name' ])
          .toString(),
        trigger: 'submit',
      },
      {
        validator: blankValidator(i18n.t(`${store.state.i18n.GLOBAL_PATH}.rules.notBlank`, [ 'Name' ]) as string),
        trigger: 'submit',
      },
    ],
    type: [
      {
        required: true,
        message: i18n.t(`${store.state.i18n.GLOBAL_PATH}.rules.required`, [ 'Type' ])
          .toString(),
        trigger: 'submit',
      },
    ],
    dateRange: [
      {
        required: true,
        message: i18n.t(`${store.state.i18n.GLOBAL_PATH}.rules.required`, [ 'Date' ])
          .toString(),
        trigger: 'submit',
      },
    ],
  });
};
